import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["personalizations"];
import { sortByPriority } from 'personalization-lib/utils/sorting';
export const strategyToVariants = _ref => {
  let {
      personalizations
    } = _ref,
    mainAsset = _objectWithoutPropertiesLoose(_ref, _excluded);
  return [...sortByPriority(personalizations), Object.assign({}, mainAsset, {
    segmentIdentifier: undefined
  })];
};

// TODO: Remove the ! once asset coordinates migration work is finished
export const getAssetIds = variants => variants.map(variant => variant.assetCoordinates.id);
export const getAssetDetails = ({
  assetCoordinates
}) => ({
  assetType: assetCoordinates.source,
  assetId: assetCoordinates.id.toString()
});